import React from "react";
import { TextField, MenuItem } from "@mui/material";

const FloatingSelectField = ({
  className = "",
  disabled = false,
  id,
  label,
  onChange,
  options = [],
  value,
  focusedAllowed = true,
}) => {
  const hasValue = !!(value && focusedAllowed);

  return (
    <TextField
      select
      className={className}
      disabled={disabled}
      id={id}
      label={label}
      onChange={onChange}
      value={value ?? ""}
      variant="outlined"
      size="small"
      sx={{
        width: "100%",
        "& .MuiFormLabel-root": {
          fontSize: "14px",
          fontFamily: "Graphik Medium",
          color: "#9A9B9B",
          paddingTop: "6px",
        },
        "& .MuiFormLabel-root.Mui-focused": {
          color: "#9A9B9B",
        },
        "& .MuiOutlinedInput-root": {
          minHeight: "55px",
          fontSize: "14px",
          color: "#000",
          fontFamily: "Graphik Medium",
          borderRadius: "12px",
          backgroundColor: hasValue ? "#ffffff" : "#f7f7f7",
          "& fieldset": {
            borderColor: hasValue ? "#11B700" : "rgba(0, 0, 0, 0.23)",
            borderWidth: hasValue ? "2px" : "1px",
            borderRadius: "12px",
          },
          "&:hover": { backgroundColor: "#ffffff" },
          "&:hover fieldset": { borderColor: "#11B700", borderWidth: "2px" },
          "&.Mui-focused": { backgroundColor: "#ffffff" },
          "&.Mui-focused fieldset": { borderColor: "#11B700", borderWidth: "2px" },
        },
        "& .MuiSelect-select": {
          padding: "14px",
          fontFamily: "Graphik Medium",
          fontSize: "14px",
        },
      }}
    >
      {options.map((option) => {
        const val = typeof option === "string" ? option : option.value;
        const lbl = typeof option === "string" ? option : option.label;
        return (
          <MenuItem key={val} value={val} sx={{ fontFamily: "Graphik Medium", fontSize: "14px" }}>
            {lbl}
          </MenuItem>
        );
      })}
    </TextField>
  );
};

export default FloatingSelectField;
